// --------------------------------------------------------------
// Created On: 2021-10-06
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./HamburgerButton.module.scss";

// A hamburger menu button for opening up a navigation drawer.
export default function HamburgerButton(props: Props): Component {
  return (
    <button
      type="button"
      className={`${styles.body} btn btn-secondary d-inline-block d-xl-none me-3`}
      onClick={() => props.onClick()}
    >
      <i className="fa fa-fw fa-bars fa-2x" data-test="hamburger-menu-button" />
    </button>
  );
}

interface Props {
  onClick: () => void;
}
